import {createContext, useContext} from "react";

const BusinessAccountSettingsContext = createContext(null);

export const useBusinessAccountSettingsContext = () =>
  useContext(BusinessAccountSettingsContext);

export default BusinessAccountSettingsContext;
